export const questions_list_keys = {
  question: {
    field: "question",
    headerName: "Question",
  },
  is_mandatory: {
    field: "is_mandatory",
    headerName: "Is mandatory",
  },
};
